import { gitCommitHash, isAdminPanel } from '@backoffice-frontend/environment'
import { FeatureTogglesView } from '@backoffice-frontend/feature-toggle'
import {
  MoiaTopBar,
  MoiaTopBarTitle,
  MoiaViewBox,
  SwitchEnvironmentDropdown,
} from '@backoffice-frontend/patterns'
import { Restricted } from '@backoffice-frontend/restricted'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { PersonIcon } from '@moia-dev/pace-icons'
import { MiniTable, MiniTableRow } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import { AboutAccountView } from './AboutAccountView'
import { AssignedOrganizationsView } from './AssignedOrganizationsView'
import { AccountLayout } from './components/AccountLayout'
import { PermissionsView } from './PermissionsView'

export const AccountView = () => {
  const { t } = useTranslation()

  return (
    <MoiaViewBox>
      <title>{t('authenticatedAppView_account_header')}</title>
      <MoiaTopBar
        leading={
          <MoiaTopBarTitle
            icon={<PersonIcon />}
            title={t('authenticatedAppView_account_header')}
          />
        }
      />
      <div
        css={theme => ({
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
          gap: theme.space.Space2,
        })}
      >
        <Restricted requiredRights={[BoumRight.DEV_USE_FEATURE_TOGGLES]}>
          <AccountLayout header={t('authenticatedAppView_environment_label')}>
            <MiniTable
              css={theme => ({
                paddingBlockEnd: theme.space.Space2,
              })}
            >
              <MiniTableRow
                label={t('authenticatedAppView_environment_label')}
                content={<SwitchEnvironmentDropdown />}
              />
              <MiniTableRow
                label={t('authenticatedAppView_gitCommitHash_label')}
                content={gitCommitHash}
              />
            </MiniTable>
            <FeatureTogglesView />
          </AccountLayout>
        </Restricted>
        {isAdminPanel ? <AssignedOrganizationsView /> : <PermissionsView />}
        <AboutAccountView />
      </div>
    </MoiaViewBox>
  )
}
